<div class="page-header">
  <app-page-title></app-page-title>
</div>

<section class="role-assign-container" aria-label="รายการตอบรับคำเชิญ">
  <div class="role-toolbar">
    <ul ngbNav #nav="ngbNav" [activeId]="activeTab()" (activeIdChange)="onTabChange($event)" class="nav-pills">
      <li [ngbNavItem]="'ALL'">
        <button ngbNavLink>
          ทั้งหมด ({{ items().length }})
        </button>
      </li>
      <li [ngbNavItem]="'PENDING'">
        <button ngbNavLink>
          รอการตอบรับ
          @if (pendingCount() > 0) {
            <span class="badge rounded-pill bg-danger ms-1">{{ pendingCount() }}</span>
          }
        </button>
      </li>
      <li [ngbNavItem]="'ACCEPTED'">
        <button ngbNavLink>
          ตอบรับแล้ว ({{ acceptedCount() }})
        </button>
      </li>
      <li [ngbNavItem]="'REJECTED'">
        <button ngbNavLink>
          ปฏิเสธแล้ว ({{ rejectedCount() }})
        </button>
      </li>
    </ul>
  </div>

  @if (loading()) {
    <div class="role-empty-state">
      <div class="spinner-border spinner-border-sm text-success" role="status"></div>
      <h4>กำลังโหลดข้อมูล...</h4>
    </div>
  } @else if (filteredItems().length === 0) {
    <div class="role-empty-state">
      <div class="empty-icon" aria-hidden="true"><i class="bi bi-envelope-open"></i></div>
      <h4>ยังไม่มีรายการตอบรับคำเชิญ</h4>
      <p>เมื่อมีผู้มอบหมายสิทธิ์การใช้งานให้คุณ รายการจะแสดงที่นี่</p>
    </div>
  } @else {
    <div class="d-none d-md-block table-responsive role-table-shell">
      <table class="table table-hover align-middle mb-0 role-table">
        <thead>
        <tr>
          <th scope="col" class="col-number">#</th>
          <th scope="col">รหัสสถานประกอบการ</th>
          <th scope="col">ชื่อสถานประกอบการ / บริษัท</th>
          <th scope="col">ผู้มอบสิทธิ์</th>
          <th scope="col">วันที่ส่งคำเชิญ</th>
<!--          <th scope="col">วันที่ตอบรับ</th>-->
          <th scope="col">สถานะ</th>
          <th scope="col" class="col-actions"></th>
        </tr>
        </thead>
        <tbody>
          @for (item of filteredItems(); track item.id; let i = $index) {
            <tr class="clickable-row" (click)="openDetail(item)">
              <td class="col-number">{{ i + 1 }}</td>
              <td class="code-cell">
                @if ((item.businesses?.length ?? 0) > 0) {
                  @for (business of item.businesses!; track business.id ?? business.businessCode) {
                    <div>{{ business.businessCode || '-' }}</div>
                  }
                } @else {
                  {{ item.grantorTaxId || '-' }}
                }
              </td>
              <td class="assignee-cell">
                @if ((item.businesses?.length ?? 0) > 0) {
                  <ul class="business-list-cell">
                    @for (business of item.businesses!; track business.id ?? business.businessName) {
                      <li>
                        <span class="fw-semibold">{{ business.businessName || '-' }}</span>
                        @if ((business.certificates?.length ?? 0) > 0) {
                          <ul class="cert-list-cell">
                            @for (cert of business.certificates!; track $index) {
                              <li>
                                {{ cert.standardName || cert.standardCode || '-' }}
                                @if (cert.standardName && cert.standardCode) {
                                  <span>({{ cert.standardCode }})</span>
                                }
                              </li>
                            }
                          </ul>
                        }
                      </li>
                    }
                  </ul>
                } @else {
                  {{ item.businessName || '-' }}
                }
              </td>
              <td class="nowrap">{{ item.grantorName || '-' }}</td>
              <td class="timestamp-cell">{{ item.createdAt | thaidatetime }}</td>
<!--              <td class="timestamp-cell">{{ item.respondedDate | thaidatetime }}</td>-->
              <td>
                <span class="status-badge" [class]="getStatusClass(item.invitationStatus)">
                  {{ getStatusLabel(item.invitationStatus) }}
                </span>
              </td>
              <td class="col-actions">
                <button type="button" class="btn btn-icon" aria-label="ดูรายละเอียด" title="ดูรายละเอียด"
                        (click)="openDetail(item); $event.stopPropagation()">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="d-md-none role-card-list">
      @for (item of filteredItems(); track item.id; let i = $index) {
        <article class="role-card" (click)="openDetail(item)">
          <div class="role-card-header">
            <span class="record-number">#{{ i + 1 }}</span>
            <span class="status-badge" [class]="getStatusClass(item.invitationStatus)">
              {{ getStatusLabel(item.invitationStatus) }}
            </span>
          </div>
          <div class="role-card-name">{{ item.businessName || item.grantorName || '-' }}</div>
          <dl class="role-card-details">
            @if ((item.businesses?.length ?? 0) > 0) {
              <div>
                <dt>รหัสสถานประกอบการ</dt>
                <dd>
                  <ul class="business-list-cell">
                    @for (business of item.businesses!; track business.id ?? business.businessName) {
                      <li>
                        <span class="fw-semibold">{{ business.businessName || '-' }}</span>
                        @if (business.businessCode) {
                          <span>({{ business.businessCode }})</span>
                        }
                        @if ((business.certificates?.length ?? 0) > 0) {
                          <ul class="cert-list-cell">
                            @for (cert of business.certificates!; track $index) {
                              <li>
                                {{ cert.standardName || cert.standardCode || '-' }}
                                @if (cert.standardName && cert.standardCode) {
                                  <span>({{ cert.standardCode }})</span>
                                }
                                @if (cert.certificateNo) {
                                  <span>({{ cert.certificateNo }})</span>
                                }
                              </li>
                            }
                          </ul>
                        }
                      </li>
                    }
                  </ul>
                </dd>
              </div>
            } @else if (item.businessCode || item.grantorTaxId) {
              <div>
                <dt>รหัสสถานประกอบการ</dt>
                <dd>{{ item.businessCode || item.grantorTaxId }}</dd>
              </div>
            }
            @if (item.grantorName) {
              <div>
                <dt>ผู้มอบสิทธิ์</dt>
                <dd>{{ item.grantorName }}</dd>
              </div>
            }
            <div>
              <dt>วันที่ส่งคำเชิญ</dt>
              <dd>{{ item.createdAt | thaidatetime }}</dd>
            </div>
            @if (item.respondedDate) {
              <div>
                <dt>วันที่ตอบรับ</dt>
                <dd>{{ item.respondedDate | thaidatetime }}</dd>
              </div>
            }
          </dl>
          <div class="role-card-actions">
            <button type="button" class="btn btn-icon" aria-label="ดูรายละเอียด"><i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </article>
      }
    </div>
  }
</section>
